import {
    BorderStyle,
    BorderThickness,
    DefaultColorsKeys,
    TabBackground,
} from "../models/DynamicCssModel";

export const DynamicCss = {
    HasGridChanges: false,

    TableRowDefaultTabBackground: TabBackground.DuoChrome.toString(),
    TableRowActiveTab: "tab-default",

    // White 100% + neutral light 100%
    TableRowDefaultTabFillPrimaryColor: DefaultColorsKeys.WhiteColor.toString(),
    TableRowDefaultTabFillPrimaryColorPercent: "100",
    TableRowDefaultTabFillSecondaryColor: DefaultColorsKeys.NeutralLightColor.toString(),
    TableRowDefaultTabFillSecondaryColorPercent: "100",

    // No Borders
    TableRowBorderStyle: BorderStyle.None,
    // If Border is selected, then light border + neutral light 100%
    TableRowBorderThickness: BorderThickness.LightSolid,
    TableRowBorderColor: DefaultColorsKeys.NeutralLightColor.toString(),
    TableRowBorderColorPercent: "100",

    // Hover Color field 1 - Neutral dark 100%
    TableRowHoverTabColor: DefaultColorsKeys.NeutralDarkColor.toString(),
    TableRowHoverTabColorPercent: "100",

    // Selected Color - Primary 100%
    TableRowSelectedTabColor: DefaultColorsKeys.PrimaryColor.toString(),
    TableRowSelectedTabColorPercent: "100",

    // Table Header Fill - Neutral dark 100%
    TableHeaderFillColor: DefaultColorsKeys.NeutralDarkColor.toString(),
    TableHeaderFillColorPercent: "100",
    TableHeaderBorderStyle: BorderStyle.None,

    // If Border is selected, then light border + Black 100%
    TableHeaderBorderThickness: BorderThickness.LightSolid,
    TableHeaderBorderColor: DefaultColorsKeys.BlackColor.toString(),
    TableHeaderBorderColorPercent: "100",
};

export default {
    ActiveHighlightValue: 0.3,
    ActiveBackgroundValue: 2.5,
    BackButtonIcon: "fas caret-left",
    BackButtonIconOnHover: false,
    BackButtonType: "icon", // icon | text | textAndIcon
    BackButtonVisible: true,
    BaseFontSize: 18,
    BorderRadius: 0,
    BorderWidth: 1,
    BottomNavigationPosition: "wrapper", // wrapper | floating
    ButtonBackground: "#F0EFEF",
    ChoiceHeight: 60,
    ChoiceSpacing: 27,
    ChoiceListIconAlignment: "left", // left | right | none
    CheckBoxIconAlignment: "left",
    CheckBoxIconType: "default", // default | custom
    ChoiceListBackgroundBorderWidth: 1,
    ChoiceListBackgroundBorderRadius: 0,
    ChoiceListBackgroundAlpha: 1,
    ControlAlpha: 1,
    ControlBackground: "#F0EFEF",
    ControlBorderColor: "#DBDBDB",
    DisplayChoiceIcon: "left", // left | right | none
    ErrorColor: "#F41134",
    EnableBacklink: true,
    FieldBorderValue: 0.5,
    FontSize: 18,
    ForegroundColorDark: "#555555",
    ForegroundColorLight: "#FFFFFF",
    GridCellMinHeight: 42,
    GridCellMinWidth: 56,
    GridCellPadding: 8,
    HeaderSizes: { H1: 23 / 18, H2: 1, H3: 16 / 18, H4: 14 / 18 },
    TickedImageUrl: "",
    UntickedImageUrl: "",
    TickedRadioImageUrl: "",
    UntickedRadioImageUrl: "",
    InputBackground: "#FFFFFF",
    InputHeight: 40,
    InputMaxWidths: { XSmall: 80, Small: 130, Medium: 260, Large: 390 },
    InputMinWidths: { XSmall: 60, Small: 120, Medium: 190, Large: 300, Full: 120 },
    LanguageSelectorVisible: true,
    LanguageSelectorLabelActive: true,
    LineHeight: 29,
    LogoAlign: "left", // left | center | right
    NextButtonIcon: "fas caret-right",
    NextButtonIconOnHover: false,
    NextButtonType: "icon", // icon | text | textAndIcon
    NeutralDarkColor: "#727272",
    NeutralLightColor: "#AEAEAE",
    BlackColor: "#000000",
    WhiteColor: "#FFFFFF",
    OptionHeight: 40,
    PageBackground: "#ffffff",
    PageSeparatorsWidth: 1,
    PageSeparatorsSpacing: 8,
    PageWrapperBackground: "rgba(255,255,255,0)",
    PageWrapperMaxWidth: 1200,
    PrimaryColor: "#0d67ca",
    ProgressBarFontSize: 11,
    ProgressBarHeight: 23,
    ProgressBarDisplay: "top", // top | bottom | topAndBottom
    ProgressBarType: "basic", // basic | discrete | floating
    ProgressBarShowValue: true,
    ProgressBarVisible: true,
    QuestionSpacing: { PageHeader: 8, PageFooter: 8, BetweenComponents: 16, WithinComponents: 8 },
    QuitButtonIcon: "fas arrow-from-left",
    QuitButtonIconOnHover: true,
    QuitButtonType: "textAndIcon", // icon | text | textAndIcon
    QuitButtonVisible: true,
    SecondaryColor: "#0b4f99",
    RadioIconType: "default", // default | custom
    ShowCheckboxSettings: true,
    ShowRadioSettings: true,
    SliderHandleSizeSmall: 12,
    SliderHandleSizeLarge: 38,
    SliderRailHeightSmall: 5,
    SliderRailHeightLarge: 10,
    SubmitButtonIcon: "fas paper-plane",
    SubmitButtonIconOnHover: true,
    SubmitButtonType: "textAndIcon", // icon | text | textAndIcon
    SubmitButtonVisible: true,
    TextFont: "Open Sans",
    TextFontSize: "16",
    TextFontVariant: "regular",
    TextTextAlign: "left", // left | center | right
    TitleFont: "Open Sans",
    TitleFontSize: "18",
    TitleFontVariant: "600",
    TitleTextAlign: "left", // left | center | right
    TopNavigationPosition: "wrapper", // wrapper | floating
    ViewResponsesButtonVisible: false,
    ContentResponsivenessOption: "resize-carousel",
    ShowStatementBackgroundSettings: true,
    StatementBorderRadius: 0,
    StatementBackgroundAlpha: 1,
    LanguageSelectorPlacement: "top-right",
    ViewResponsesButtonPlacement: "top-right",
    BackButtonPlacement: "bottom-left",
    SubmitButtonPlacement: "bottom-right",
    NextButtonPlacement: "bottom-right",
    QuitButtonPlacement: "bottom-center",
    CustomBorderValue: false,
    BackButtonDisplayBothTopBottom: false,
    SubmitButtonDisplayBothTopBottom: false,
    NextButtonDisplayBothTopBottom: false,
    QuitButtonDisplayBothTopBottom: false,
    DynamicCss,
};
